import LOAN_DETAILS from './loan-details'
import LOAN_HISTORY from './loan-history'
import { PAYMENT_SCHEDULE, PAYMENT_AMOUNT } from './payment-schedule'

export const PPS_DETAIL_LAYOUT_SETTING = {
  LOAN_DETAILS,
  LOAN_HISTORY,
  PAYMENT_SCHEDULE,
  PAYMENT_AMOUNT
}
